import { useRef, useState } from 'react';
import { Camera, ImageSquare, Trash } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { api, API } from '../lib/api';

const MAX_MB = 5;

export const ProductPhoto = ({ product, onChanged }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const src = product.foto_path ? `${API}/files/${product.foto_path}` : null;

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { toast.error('Format foto harus JPG, PNG, atau WEBP'); return; }
    if (file.size > MAX_MB * 1024 * 1024) { toast.error(`Ukuran foto maksimal ${MAX_MB} MB`); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      await api.post(`/products/${product.id}/photo`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success(src ? 'Foto produk diganti' : 'Foto produk ditambahkan');
      onChanged();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal mengunggah foto');
    } finally {
      setBusy(false);
    }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await api.delete(`/products/${product.id}/photo`);
      toast.success('Foto dihapus');
      onChanged();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal menghapus foto');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="group relative -mx-5 -mt-5 mb-1 aspect-[4/3] bg-secondary/60 rounded-t-xl overflow-hidden" data-testid={`product-photo-${product.id}`}>
      {src ? (
        <img src={src} alt={product.nama} className="w-full h-full object-cover" data-testid={`product-photo-img-${product.id}`} />
      ) : (
        <button type="button" onClick={() => inputRef.current?.click()} disabled={busy}
          className="w-full h-full flex flex-col items-center justify-center gap-2 text-muted-foreground hover:text-primary transition-colors"
          data-testid={`btn-photo-empty-${product.id}`}>
          <ImageSquare size={40} weight="duotone" />
          <span className="text-sm">{busy ? 'Mengunggah…' : 'Tambah foto produk'}</span>
        </button>
      )}
      {src && (
        <div className="absolute bottom-2 right-2 flex gap-1.5">
          <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`btn-photo-change-${product.id}`}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/60 text-white text-xs backdrop-blur hover:bg-black/75 transition-colors disabled:opacity-60">
            <Camera size={14} /> {busy ? 'Mengunggah…' : 'Ganti Foto'}
          </button>
          <button type="button" onClick={remove} disabled={busy} data-testid={`btn-photo-remove-${product.id}`} title="Hapus foto"
            className="p-1.5 rounded-full bg-black/60 text-white backdrop-blur hover:bg-rose-600 transition-colors">
            <Trash size={14} />
          </button>
        </div>
      )}
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={upload} data-testid={`input-photo-${product.id}`} />
    </div>
  );
};
